import { Component, Input, OnChanges } from '@angular/core';
import { DISCHARGED_BATTERY_LEVEL } from '../../models/band-status';

@Component({
  selector: 'app-battery-level',
  templateUrl: './battery-level.component.html',
  styleUrls: ['./battery-level.component.scss']
})
export class BatteryLevelComponent implements OnChanges {

  @Input() batteryLevel: number = 0;
  /** Opaska na ładowarce — na baterii pojawia się piorun. */
  @Input() charging: boolean = false;

  public level: number = 0;

  constructor() {}

  /**
   * `ngOnChanges`, nie `ngOnInit`: poziom przychodzi z socketu i zmienia się
   * w trakcie życia kafelka, a przy `ngOnInit` bateria zostawała na pierwszym odczycie.
   */
  ngOnChanges() {
    const raw = Number(this.batteryLevel);
    this.level = Math.min(100, Math.max(0, isNaN(raw) ? 0 : raw));
  }

  /**
   * Piorun tylko dopóki jest co ładować. is_charge nie gaśnie po dojściu do 100%
   * (patrz startCharge w socket.service.ts) — pełna opaska leżąca na ładowarce
   * pokazywałaby piorun w nieskończoność; ta sama reguła co „Naładowana" w app-check-status-user.
   */
  get showCharging(): boolean {
    return !!this.charging && this.level < 100;
  }

  /**
   * Wykrzyknik tylko bez ładowania — na ładowarce piorun mówi więcej niż „pusta".
   * Próg (0–15% włącznie) wspólny z app-check-status-user, które podpisuje ją „Band discharged".
   * Brak odczytu to `null`, którego wołający nie pokazują wcale.
   */
  get discharged(): boolean {
    return !this.charging && this.level <= DISCHARGED_BATTERY_LEVEL;
  }

}
